export const home = {
  labels: {
    games: "News",
    company: "Company",
    facebook: "facebook",
    instagram: "instagram",
    twitter: "twitter",
    terms_of_use: "Terms of use",
    privacy: "Privacy Police",
  },
  tooltips: {
    go_to: {
      facebook: "Go to Facebook",
      instagram: "Go to Instagram",
      twitter: "Go to Twitter",
    },
  },
  banner: {
    title: "More than 2 billion videos watched every month.",
    subtitle: "The largest gaming audience on social media",
  },
  games: {
    title: "",
    resume: "",
    items: {
      section1: "Video Creation powered by A.I",
      section2: "Over 100 active channels in 7 languages",
      section3: "The largest gaming audience on social media",
      section4: "340 million unique monthly viewers worldwide",
    },
  },
  company: {
    about: [
      "Lorem Ipsum is simply <strong>dummy text</strong> of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    ],
  },
  footer: {
    resume:
      "Prota Games uses AI to scale the world's most engaging gaming content on social media",
    copyright: "Prota Games, all rights reserved",
  },
};
